<template>
  <div class="bgColor text-sm">
    <div class="px-4 mx-auto py-10 sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
      <div class="grid row-gap-10 lg:grid-cols-6">
        <div class="grid grid-cols-2 gap-5 row-gap-8 lg:col-span-6 md:grid-cols-6">
          <!--     第一列     -->
          <div class="borderLineColor border-opacity-10">
            <p class="font-medium tracking-wide text-gray-300">临床服务</p>
            <ul class="mt-2 space-y-2">
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="toClinical(1)">多学科会诊</a>
              </li>
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="toClinical(1)">第二诊疗意见</a>
              </li>
            </ul>
          </div>

          <!--     第二列     -->
          <div class="borderLineColor border-opacity-10">
            <p class="font-medium tracking-wide text-gray-300">在线教育</p>
            <ul class="mt-2 space-y-2">
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="toEdu(0)">精彩直播</a>
              </li>
              <!--              <li>-->
              <!--                <a href="javascript:;" class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200" @click="toEdu(1)">认证教育</a>-->
              <!--              </li>-->
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="toEdu(2)">学位教育</a>
              </li>
            </ul>
          </div>

          <!--     第三列     -->
          <div class="borderLineColor border-opacity-10">
            <p class="font-medium tracking-wide text-gray-300">科学研究</p>
            <ul class="mt-2 space-y-2">
              <li>
                <a href="javascript:;" @click="toScience(0)"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200">成果转化</a>
              </li>
              <li>
                <a href="javascript:;" @click="toScience(1)"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200">产业基金</a>
              </li>
              <li>
                <a href="javascript:;" @click="toScience(2)"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200">生命科学园</a>
              </li>
            </ul>
          </div>

          <!--     第四列     -->
          <div class="borderLineColor border-opacity-10">
            <p class="font-medium tracking-wide text-gray-300">EMHUB</p>
            <ul class="mt-2 space-y-2">
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="toNewsList">新闻</a>
              </li>
              <!--              <li>-->
              <!--                <a href="javascript:;" class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200">活动</a>-->
              <!--              </li>-->
              <li>
                <a href="javascript:;"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  @click="support">联系我们</a>
              </li>
            </ul>
          </div>

          <!--     第五列     -->
          <div>
            <p class="font-medium tracking-wide text-gray-300">友情链接</p>
            <ul class="mt-2 space-y-2">
              <li>
                <a href="javascript:;" @click="toOutAddresss('http://www.silvermountain.com.cn/index.asp')"
                  class="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200">银山集团</a>
              </li>
            </ul>
          </div>

          <div class="flex flex-col justify-end sm:flex-row">
          </div>

        </div>
      </div>
    </div>
    <!--  底部  -->
    <div class="bgFooterColor">
      <div
        class="flex flex-col justify-center px-4 mx-auto py-5 border-gray-800 sm:flex-row sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
        <p class="text-sm text-gray-500">
          © 2022-2023 All Rights Reserved. <a href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank">京ICP备2022009093号</a> 增值电信业务经营许可证：京B2-20222230
        </p>
      </div>
      <div
        style="width:300px;margin:0 auto; padding:20px 0;"
      >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050220"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img :src="baseOSSUrl + '/beian.png'" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502050220号</p></a>
      </div>
    </div>

  </div>
</template>

<script>
import { baseOSSUrl } from '../utils/oss';
  export default {
    name: 'homeFooter',
    data() {
      return {
        baseOSSUrl
      }
    },
    methods: {
      //跳转外部链接
      toOutAddresss(value) {
        window.open(value, '_blank');
      },
      //跳转科学研究页面事件
      toScience(value) {
        this.$router.replace({
          name: 'scienceResearch',
          query: {
            tabIndex: value
          }
        })
      },
      //跳转新闻列表
      toNewsList() {
        this.$router.push({
          name: 'newsList',
        })
      },
      //联系我们
      support() {
        this.$router.push({
          name: 'support',
        })
      },
      //跳转教育页面
      toEdu(value) {
        this.$router.replace({
          name: 'edu',
          query: {
            tabIndex: value
          }
        })
      },
      //跳转合作伙伴页面事件
      //跳转临床页面事件
      toClinical(value) {
        this.$router.replace({
          name: 'clinicalService',
          query: {
            tabIndex: value
          }
        })
      },
    }
  }
</script>


<style scoped>
  .bgColor {
    background-color: #1F2025;
  }

  .bgFooterColor {
    background-color: #000000;
  }

  .borderLineColor {
    border-right-width: 1px;
  }
</style>